const { getDefaultPaymentChannel } = require('@/lib/Channels');

/**
 * Some API endpoints (order adjustments) don't return all the many extra entities
 * we'd like to know information about when dealing with an order. This isn't necessarily
 * an issue with the API because it's a lot of data for one endpoint to return, just inconvenient.
 * This class deals with attaching entities to an order and its lines, such as items, sessions and branches,
 * which we can load from our own storage.
 */
class OrderRelationAttacher {
    /**
     * @param {ItemRepository} itemRepository
     * @param {SessionRepository} sessionRepository
     * @param {UserService} userService
     */
    constructor(
        itemRepository,
        sessionRepository,
        userService
    ) {
        this.itemRepository = itemRepository;
        this.sessionRepository = sessionRepository;
        this.userService = userService;
    }

    /**
     * @param {Order} order
     */
    async attachRelationsToOrder(order) {
        await Promise.all(
            [
                // Attach items entities to order lines.
                this.itemRepository.attachItemsToOrderLines(
                    order.getLines()
                ),

                // Attach sessions to order lines.
                this.sessionRepository.attachSessionsToOrderLines(
                    order.getLines()
                ),
            ]
        );

        // Attach branches to order lines.
        this.userService.attachBranchesToOrderLines(
            order.getLines()
        );
    }

    attachDefaultPaymentChannelToOrder(order) {
        if (!order.paymentChannel) {
            order.paymentChannel = getDefaultPaymentChannel();
        }
    }
}

module.exports = OrderRelationAttacher;
